import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=44110a68&scoped=true&"
import script from "./FooterView.vue?vue&type=script&lang=js&"
export * from "./FooterView.vue?vue&type=script&lang=js&"
import style0 from "./FooterView.vue?vue&type=style&index=0&id=44110a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44110a68",
  null
  
)

export default component.exports